import { useEffect, useState } from "react";
import { JournalForm } from "../../Components/JournalForm/JournalForm";
import { useGetAllJournalEntriesFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { JournalIntroduction } from "../../Components/JournalIntroduction/JournalIntroduction";
import { useLocation, useNavigate } from "react-router-dom";
import { useNavBarContext } from "core/state/NavBarContext/NavBarContext";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { useTranslation } from "react-i18next";
import { JournalLoader } from "../../Components/JournalLoader/JournalLoader";
import { parseDateToString } from "core/helpers/dates";

export const CreateJournalEntry = () => {
  const { t } = useTranslation();
  const { state: journalEntryData } = useLocation();
  const titleDate = parseDateToString(new Date(journalEntryData?.date ?? 0));

  useNavBarContext({ title: journalEntryData?.date ? titleDate : t("positiveYou.create.navTitle") });

  const navigate = useNavigate();
  const [showJournalIntroduction, setShowJournalIntroduction] = useState(false);
  const { data, isLoading } = useGetAllJournalEntriesFunctionRequest({
    xClientCode: ClientInfoState.getCode(),
  });

  useEffect(() => {
    if (data?.metaData.totalCount === 0) {
      setShowJournalIntroduction(true);
    } else {
      setShowJournalIntroduction(false);
    }
  }, [data?.metaData.totalCount, isLoading]);

  const handleMainBack = () => {
    if (data?.metaData.totalCount === 0) {
      setShowJournalIntroduction(true);
    } else {
      navigate(-1);
    }
  };

  if (isLoading) return <JournalLoader />;

  return (
    <>
      <PageTitle title={t("pageTitle.positiveYou.create")} />
      {showJournalIntroduction ? (
        <JournalIntroduction onClickStarted={() => setShowJournalIntroduction(false)} />
      ) : (
        <JournalForm handleMainBack={handleMainBack} />
      )}
    </>
  );
};
